module.exports = __webpack_public_path__ + "img/home-title.7904b43e.png";